import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import "css/main.css";
import "css/style.css";

import Account from "components/definitions/Account";
import Invoices from "components/definitions/Invoices";
import Topnav from "components/Topnav";

function AccountDefinitions() {
  const [activeTab, setActiveTab] = useState("account");
  const { t } = useTranslation();

  return (
    <div className="geral">
      <Topnav></Topnav>
      <div className="conteudo">
        <section className="section">
          <nav className="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <li className="is-active">{t("definitions")}</li>
            </ul>
          </nav>

          <div className="hero is-footsolution">
            <div className="columns">
              <div className="column">
                <h1 className="title is-3">{t("consult_change")} </h1>
              </div>
            </div>
          </div>

        </section>

        <section className="tab-content">
          {activeTab === "account" && <Account />}
          {activeTab === "invoices" && <Invoices />}
          {activeTab === "perfil" && <Invoices />}
        </section>
      </div>
    </div>
  );
}

export default AccountDefinitions;

